// src/helpers/factories/menuSubcategoryCardFactory.ts
var menuSubcategoryCardFactory = (subcategories) => Object.values(subcategories).map((subcategory) => ({
  id: subcategory.subcategoryId,
  title: subcategory.name,
  categoryId: subcategory.categoryId || 0,
  itemCount: subcategory.itemIds.length,
  status: subcategory.active,
  activeFilter: subcategory.active ? 1 : 2
}));
var dropdownSubcategoryOptionFactory = (subcategories) => Object.values(subcategories).map((subcategory) => ({
  label: subcategory.name,
  value: subcategory.subcategoryId || 0,
  categoryId: subcategory.categoryId || 0,
  inActive: !subcategory.active
}));

export { dropdownSubcategoryOptionFactory, menuSubcategoryCardFactory };
